import { Pipe } from "@angular/core";
import { MarcacaoConsulta } from "../marcacao/marcacao-consulta/marcacao-consulta";
import { MoedaFormatadaGenericaPipe } from "./moeda-formatada-generica-pipe";

@Pipe({
    name: 'moedaFormatadaPipe',
    pure: true
})

export class MoedaFormatadaPipe extends MoedaFormatadaGenericaPipe {

    transform(marcacaoConsulta: MarcacaoConsulta, currencyCode: string = 'BRL', symbolDisplay: string = 'symbol', digits?: string): string {
        if (marcacaoConsulta && !marcacaoConsulta.cobrarProcedimentoConsulta) {
            return '---';
        }

        return super.transform(marcacaoConsulta.procedimentoConsulta.valor, currencyCode, symbolDisplay, digits)
    }
}
